import { deepCompare } from '@co4cloud/graph';
import { memo } from 'react';
import { getNestedValue } from '../utils';
import { ColumnData } from './DnDTable';

interface DnDTableCellProps {
  cell: ColumnData;
  index: number;
  data: Record<string, string | number>;
}

const DnDTableCell: React.FC<DnDTableCellProps> = (props) => {
  const { cell, index, data } = props;
  return (
    <td data-value={getNestedValue(data, cell.field)}>
      {cell.renderer
        ? cell.renderer({ ...data, rowValue: getNestedValue(data, cell.field), index })
        : getNestedValue(data, cell.field) ?? '-'}
    </td>
  );
};

export default memo(DnDTableCell, deepCompare);
